import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getActiveExperiments as getGlobalActiveExperiments } from '@atc/optimizely-toolkit';

import experimentDuck from '@/ducks/experimentDuck';

export default function useExperiments() {
    const experiments = useSelector(experimentDuck.selectors.getExperiments);

    const dispatch = useDispatch();

    const getActiveExperiments = useCallback(() => {
        if (experiments.length > 0) {
            return experiments;
        }

        return getGlobalActiveExperiments();
    }, [experiments]);

    const onDecision = useCallback((activeExperiments) => {
        dispatch(experimentDuck.creators.addExperiments(activeExperiments));
    }, [dispatch]);

    const listenerConfig = useMemo(() => ({
        onDecision,
    }), [onDecision]);

    return {
        getActiveExperiments,
        listenerConfig,
    };
}
